import {FC} from 'react'
import SummaryItem from './SummaryItem'
import capitalize from 'lodash/capitalize'
import {paymentStatusTypes} from 'app/constant'
import clsx from 'clsx'

interface Props {
  totalDiscounts: number
  wineClubDiscounts: number
  totalPrice: number
  paymentMethod?: any
  discountTitle?: string | any
  wineClubDiscountTitle?: string | any
  children?: React.ReactNode
  financialStatus?: string
  refundPrice?: any | number
  totalTitle?: string
  paidAmountTitle?: string
  unPaidAmountTitle?: string
  refundTitle?: string
  hideDiscounts?: boolean
  hidePaymentMethod?: boolean
  isBetween?: boolean
  cardInfo?: any
  wineClubDiscountChild?: any
  totalAmountPaid?: any
}

const SummaryFooter: FC<Props> = ({
  totalPrice,
  totalDiscounts,
  wineClubDiscounts,
  paymentMethod,
  discountTitle = 'Discount',
  wineClubDiscountTitle = 'Wine Club Discount',
  children,
  financialStatus,
  refundPrice,
  refundTitle = 'Amount to Be Refunded',
  totalTitle = 'Total Amount',
  paidAmountTitle = 'Total Paid By Customer',
  unPaidAmountTitle = 'Total Unpaid Amount',
  hideDiscounts,
  hidePaymentMethod,
  isBetween,
  cardInfo,
  wineClubDiscountChild,
  totalAmountPaid,
}) => {
  const show = () => {
    if (
      financialStatus === paymentStatusTypes.pending ||
      financialStatus === paymentStatusTypes.failed
    )
      return false
    return true
  }
  return (
    <>
      {!hideDiscounts && (
        <div className='card-footer'>
          <SummaryItem
            title={wineClubDiscountTitle}
            value={wineClubDiscounts}
            isValueBolder
            isDiscount
            isBetween={isBetween}
          >
            {wineClubDiscountChild}
          </SummaryItem>
          <SummaryItem
            title={discountTitle}
            value={totalDiscounts}
            isValueBolder
            isDiscount
            isBetween={isBetween}
          />
        </div>
      )}
      {paymentMethod && paymentMethod.id && show() ? (
        <div className={clsx('card-footer', !isBetween && 'd-flex flex-column align-items-center')}>
          {financialStatus === paymentStatusTypes.partiallyPaid && (
            <SummaryItem
              title={paidAmountTitle}
              value={totalAmountPaid}
              isValueSuccess
              isValueBolder
              isBetween={isBetween}
              isTitleBolder
            />
          )}
          <SummaryItem
            title={totalTitle}
            value={totalPrice}
            isValueBolder
            isBetween={isBetween}
            isTitleBolder
          >
            {!hidePaymentMethod && paymentMethod && paymentMethod.id && show() && (
              <span className='text-muted'>
                By Credit : {capitalize(paymentMethod.card?.brand)} ending in{' '}
                {paymentMethod.card?.last4}
              </span>
            )}
          </SummaryItem>
        </div>
      ) : (
        <div className={clsx('card-footer', !isBetween && 'd-flex flex-column align-items-center')}>
          {financialStatus === paymentStatusTypes.partiallyPaid && (
            <SummaryItem
              title={paidAmountTitle}
              value={totalAmountPaid}
              isValueBolder
              isBetween={isBetween}
              isTitleBolder
            />
          )}
          <SummaryItem
            title={totalTitle}
            value={totalPrice}
            isValueBolder
            isBetween={isBetween}
            isTitleBolder
          >
            {!hidePaymentMethod && paymentMethod && paymentMethod.id && show() && (
              <span className='text-muted'>
                By Credit : {capitalize(cardInfo.brand)} ending in {cardInfo?.last4}
              </span>
            )}
          </SummaryItem>
        </div>
      )}

      {parseFloat(refundPrice) > 0 && (
        <div className={clsx('card-footer', !isBetween && 'd-flex align-items-center')}>
          <SummaryItem
            title={refundTitle}
            value={refundPrice}
            isValueBolder
            isTitleBolder
            isBetween={isBetween}
            isValueDanger
          >
            {paymentMethod && paymentMethod.id && show() && (
              <span className='text-muted'>
                to {capitalize(paymentMethod.card?.brand)} ending in {paymentMethod.card?.last4}
              </span>
            )}
          </SummaryItem>
        </div>
      )}
      {children}
    </>
  )
}

export default SummaryFooter
